const swList = {
  370357: 199,
  383730: 199,
  370425: 249,
  392994: 299,
  382727: 299,
  373116: 299,
  373118: 299,
  374677: 399,
  382725: 399,
  393760: 399,
  394675: 399,
  386464: 499,
  394677: 499,
  386466: 599,
  397922: 979,
  373430: 999,
  370439: 299,
  386344: 299,
  371895: 399,
  392731: 399,
  370721: 399,
  391991: 399,
  375138: 499,
  392911: 599,
  382723: 599,
  375774: 599,
  385948: 599,
  371897: 599,
  384481: 599,
  392996: 699,
  385885: 699,
  382721: 799,
  382719: 799,
  371918: 799,
  391987: 799,
  384483: 799,
  397918: 979,
  375142: 999,
  385116: 999,
  372619: 999,
  383429: 999,
  385025: 999,
  374145: 1499,
  397246: 1499,
  370782: 399,
  396492: 599,
  386501: 999,
  375073: 1499,
  385475: 1599,
  386074: 299,
  370582: 299,
  391493: 299,
  386969: 349,
  370437: 399,
  392129: 399,
  391495: 399,
  396747: 399,
  384980: 399,
  385662: 499,
  392326: 499,
  392748: 599,
  377110: 599,
  393835: 599,
  374852: 599,
  380124: 599,
  372405: 599,
  370719: 599,
  385027: 599,
  396658: 699,
  375152: 699,
  375016: 799,
  376258: 799,
  396413: 799,
  372849: 799,
  385029: 799,
  372509: 899,
  391989: 899,
  397920: 979,
  372507: 999,
  373666: 999,
  385601: 999,
  387631: 999,
  372006: 999,
  375144: 999,
  372983: 999,
  384502: 1299,
  393758: 1299,
  384498: 1299,
  394924: 1499,
  373664: 1499,
  394929: 1799,
  394934: 1999,
};

export default function getPaymentType(swNumber) {
  return swList[swNumber] && swList[swNumber] >= 600 ? 'yearly' : 'monthly'; // default to monthly
}
